import { arrayOrArray } from '@apia/util';
import { classToValidate, Radio } from '@apia/validations';
import React from 'react';
import { TApiaApiField } from '../ApiaApiHandler';

export const ApiaApiRadio = (props: TApiaApiField) => {
  const element = React.useMemo(() => props.element, [props.element]);
  const className = React.useMemo(
    () =>
      element.class ? `handler__radio ${element.class}` : 'handler__radio',
    [element.class],
  );
  const options = React.useMemo(
    () =>
      arrayOrArray(element.options?.option).map((currOption) => {
        return { value: currOption.value, label: currOption.content };
      }),
    [element.options?.option],
  );
  const validationRules = React.useMemo(
    () => ({
      required: element.mandatory,
      ...classToValidate(element.class),
    }),
    [element.class, element.mandatory],
  );
  return (
    <Radio
      className={className}
      name={element.id || element.name}
      label={element.text}
      title={element.title || element.text}
      initialValue={element.value}
      disabled={element.readonly || element.disabled}
      validationRules={validationRules}
      options={options}
      onChange={element.onChange}
    />
  );
};

ApiaApiRadio.displayName = 'ApiaApiRadio';
